/* MAISON NUYA — Pop-up de langue / pays (logique). Balisage : sections/nuya-geo-popup.liquid */
(function () {
  var COOKIE = 'nuya_geo_seen';
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function readCookie(name) {
    return document.cookie.split('; ').some(function (entry) {
      return entry.indexOf(name + '=') === 0;
    });
  }

  function writeCookie(name, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=1; expires=' + date.toUTCString() + '; path=/; SameSite=Lax';
  }

  function panels() {
    return window.Nuya && window.Nuya.panels ? window.Nuya.panels : null;
  }

  function initGeo(root) {
    if (root.nuyaReady) return;
    root.nuyaReady = true;
    if (window.Shopify && window.Shopify.designMode) return;

    /* ?nuya_geo=test → 1re destination ; ?nuya_geo=GB → destination GB. */
    var forcedMatch = window.location.search.match(/[?&]nuya_geo=([^&]*)/);
    var forced = forcedMatch !== null;
    var forcedCountry = forced ? decodeURIComponent(forcedMatch[1]).toUpperCase() : '';

    if (readCookie(COOKIE) && !forced) return;

    var currentCountry = (root.dataset.currentCountry || '').toUpperCase();
    var currentLocale = (root.dataset.currentLocale || '').toLowerCase();
    var availableCountries = (root.dataset.availableCountries || '').toUpperCase().split(',').filter(Boolean);
    var delay = forced ? 0 : (parseInt(root.dataset.delay, 10) || 3) * 1000;
    var cookieDays = parseInt(root.dataset.cookieDays, 10) || 90;
    var titleTemplate = root.dataset.titleTemplate || '';

    var choices = Array.prototype.slice.call(root.querySelectorAll('[data-nuya-geo-choice]'));
    if (!choices.length) return;

    var modal = root.querySelector('[data-nuya-geo-modal]');
    var countryInput = root.querySelector('[data-nuya-geo-country]');
    var returnInput = root.querySelector('[data-nuya-geo-return]');
    var localeInputs = Array.prototype.slice.call(root.querySelectorAll('[data-nuya-geo-locale]'));
    var labelNode = root.querySelector('[data-nuya-geo-label]');
    var flagNode = root.querySelector('[data-nuya-geo-flag]');
    var heroFlagNode = root.querySelector('[data-nuya-geo-hero-flag]');
    var titleNode = root.querySelector('[data-nuya-geo-title]');
    var ctaNode = root.querySelector('[data-nuya-geo-cta]');
    var declineNode = root.querySelector('[data-nuya-geo-decline]');
    var trigger = root.querySelector('[data-nuya-geo-trigger]');
    var options = root.querySelector('[data-nuya-geo-options]');
    var form = root.querySelector('form');

    /* Chemin de retour sans préfixe de langue, paramètres conservés (sauf nuya_geo). */
    function syncReturnPath() {
      if (!returnInput) return;
      var path = window.location.pathname || '/';
      var rootUrl = root.dataset.rootUrl || '/';
      if (rootUrl !== '/' && path.indexOf(rootUrl) === 0) path = path.slice(rootUrl.length);
      if (path.charAt(0) !== '/') path = '/' + path;
      var params = window.location.search
        .replace(/^\?/, '')
        .split('&')
        .filter(function (pair) {
          return pair && pair.indexOf('nuya_geo=') !== 0;
        });
      returnInput.value = path + (params.length ? '?' + params.join('&') : '');
    }

    function select(choice) {
      if (!choice) return;
      if (countryInput) countryInput.value = choice.dataset.country;
      localeInputs.forEach(function (input) {
        input.value = choice.dataset.locale;
      });
      choices.forEach(function (other) {
        other.setAttribute('aria-selected', other === choice ? 'true' : 'false');
      });
      var flag = choice.querySelector('.nuya-geo__flag');
      var text = choice.querySelector('.nuya-geo__option-label');
      if (labelNode) labelNode.textContent = text ? text.textContent.trim() : choice.textContent.trim();
      if (flagNode) flagNode.innerHTML = flag ? flag.innerHTML : '';
      if (heroFlagNode) heroFlagNode.innerHTML = flag ? flag.innerHTML : '';
      if (ctaNode && choice.dataset.cta) ctaNode.textContent = choice.dataset.cta;
      /* Refus dans la langue de la destination. */
      if (declineNode && choice.dataset.decline) declineNode.textContent = choice.dataset.decline;
    }

    function open(countryName, choice, destCountry) {
      select(choice);
      syncReturnPath();
      /* Devise du vrai pays détecté, langue de la destination choisie. */
      if (destCountry && countryInput) countryInput.value = destCountry;

      /* Titre propre à la destination ; nom du pays rédigé dans sa langue
         seulement si la destination correspond au pays détecté. */
      if (titleNode) {
        var template = (choice && choice.dataset.title) || titleTemplate;
        var name = countryName || '';
        if (
          choice &&
          choice.dataset.titleCountry &&
          (choice.dataset.country || '').toUpperCase() === (destCountry || '').toUpperCase()
        ) {
          name = choice.dataset.titleCountry;
        }
        if (template) titleNode.textContent = template.replace('[pays]', name);
      }

      root.hidden = false;
      void root.offsetHeight;

      if (panels()) {
        panels().open(root);
      } else {
        root.dataset.open = 'true';
        document.body.classList.add('nuya-no-scroll');
        if (window.Nuya && window.Nuya.lenis) window.Nuya.lenis.stop();
        var closeButton = root.querySelector('.nuya-geo__close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      }
    }

    function afterClose() {
      writeCookie(COOKIE, cookieDays);
      window.setTimeout(function () {
        root.hidden = true;
      }, 320);
    }

    root.addEventListener('nuya:panel:close', afterClose);

    function close() {
      if (root.dataset.open !== 'true') return;
      if (panels()) {
        panels().close(root);
        return;
      }
      root.dataset.open = 'false';
      document.body.classList.remove('nuya-no-scroll');
      if (window.Nuya && window.Nuya.lenis) window.Nuya.lenis.start();
      afterClose();
    }

    root.querySelectorAll('[data-nuya-geo-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });

    function expanded() {
      return trigger && trigger.getAttribute('aria-expanded') === 'true';
    }

    function collapse(refocus) {
      if (!trigger || !options) return;
      trigger.setAttribute('aria-expanded', 'false');
      options.hidden = true;
      if (refocus) trigger.focus({ preventScroll: true });
    }

    function expand() {
      if (!trigger || !options) return;
      trigger.setAttribute('aria-expanded', 'true');
      options.hidden = false;
      var active = choices.filter(function (choice) {
        return choice.getAttribute('aria-selected') === 'true';
      })[0];
      (active || choices[0]).focus({ preventScroll: true });
    }

    function moveFocus(from, step) {
      var index = choices.indexOf(from);
      var next = choices[(index + step + choices.length) % choices.length];
      if (next) next.focus({ preventScroll: true });
    }

    if (trigger && options) {
      trigger.addEventListener('click', function () {
        if (expanded()) collapse(false);
        else expand();
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === ' ') {
          event.preventDefault();
          expand();
        }
      });

      options.addEventListener('keydown', function (event) {
        var current = event.target.closest('[data-nuya-geo-choice]');
        if (!current) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          moveFocus(current, 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          moveFocus(current, -1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          choices[0].focus({ preventScroll: true });
        } else if (event.key === 'End') {
          event.preventDefault();
          choices[choices.length - 1].focus({ preventScroll: true });
        } else if (event.key === 'Tab') {
          collapse(false);
        }
      });

      document.addEventListener('click', function (event) {
        if (options.hidden) return;
        if (!event.target || !event.target.closest) return;
        if (event.target.closest('[data-nuya-geo-select]')) return;
        collapse(false);
      });
    }

    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        select(choice);
        collapse(true);
      });
    });

    /* Échap ferme la liste d'abord, puis le pop-up (capture, avant Nuya.panels). */
    document.addEventListener(
      'keydown',
      function (event) {
        if (root.dataset.open !== 'true') return;
        if (event.key === 'Escape' && options && !options.hidden) {
          event.preventDefault();
          event.stopPropagation();
          collapse(true);
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          close();
          return;
        }
        if (event.key !== 'Tab' || !modal) return;
        var items = Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE)).filter(function (node) {
          return node.offsetParent !== null || node === document.activeElement;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      },
      true
    );

    if (form) {
      form.addEventListener('submit', function () {
        syncReturnPath();
        writeCookie(COOKIE, cookieDays);
      });
    }

    function findChoice(countryCode) {
      var code = (countryCode || '').toUpperCase();
      if (!code) return null;
      for (var i = 0; i < choices.length; i++) {
        if ((choices[i].dataset.country || '').toUpperCase() === code) return choices[i];
      }
      return null;
    }

    function findChoiceByLocale(localeCode) {
      var code = (localeCode || '').toLowerCase();
      if (!code) return null;
      var i;
      for (i = 0; i < choices.length; i++) {
        if ((choices[i].dataset.locale || '').toLowerCase() === code) return choices[i];
      }
      var base = code.split('-')[0];
      for (i = 0; i < choices.length; i++) {
        if ((choices[i].dataset.locale || '').toLowerCase().split('-')[0] === base) return choices[i];
      }
      return null;
    }

    function navigatorChoice() {
      var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
      for (var i = 0; i < langs.length; i++) {
        var choice = findChoiceByLocale(langs[i]);
        if (choice) return choice;
      }
      return null;
    }

    function propose(choice, countryName, countryCode) {
      if (!choice) return;
      var code = (countryCode || '').toUpperCase();
      var destCountry =
        code && availableCountries.indexOf(code) !== -1 ? code : (choice.dataset.country || '').toUpperCase();
      var destLocale = (choice.dataset.locale || '').toLowerCase();
      var localeChanges = destLocale && destLocale !== currentLocale;
      var countryChanges = destCountry && destCountry !== currentCountry;
      if (!localeChanges && !countryChanges && !forced) {
        writeCookie(COOKIE, cookieDays);
        return;
      }
      window.setTimeout(function () {
        open(countryName || choice.dataset.countryName || '', choice, destCountry);
      }, delay);
    }

    if (forced) {
      var testChoice = findChoice(forcedCountry) || choices[0];
      propose(testChoice, testChoice.dataset.countryName, testChoice.dataset.country);
      return;
    }

    /* Suggestion Shopify (IP), puis langue du navigateur en secours. */
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || root.dataset.rootUrl || '/';

    fetch(
      rootUrl + 'browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&language[enabled]=true',
      { headers: { Accept: 'application/json' } }
    )
      .then(function (response) {
        if (!response.ok) throw new Error('no_suggestion');
        return response.json();
      })
      .then(function (data) {
        var detected = data && data.detected_values;
        var country = detected && detected.country;
        if (!country || !country.handle) throw new Error('no_country');
        var code = String(country.handle).toUpperCase();
        var suggestedLocale = '';
        if (detected.language) {
          suggestedLocale = String(detected.language.handle || detected.language.iso_code || '').toLowerCase();
        }
        if (code === currentCountry && (!suggestedLocale || suggestedLocale === currentLocale)) {
          writeCookie(COOKIE, cookieDays);
          return;
        }
        var choice = null;
        if (code !== currentCountry) choice = findChoice(code);
        if (!choice && suggestedLocale && suggestedLocale !== currentLocale) choice = findChoiceByLocale(suggestedLocale);
        if (!choice) choice = navigatorChoice();
        if (!choice) {
          writeCookie(COOKIE, cookieDays);
          return;
        }
        propose(choice, country.name, code);
      })
      .catch(function () {
        propose(navigatorChoice());
      });
  }

  function run(scope) {
    (scope || document).querySelectorAll('[data-nuya-geo]').forEach(initGeo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();